<template>
  <div class="container pull-up">
    <div class="row">
      <div class="col-md-12">
        <!--<div class="card m-b-30">
          <div class="card-header">
            <h5 class="m-b-0">
            </h5>
          </div>
          <div class="card-body">
            <el-steps :active="active" finish-status="success" align-center>
              <el-step v-for="step in steps" :title="step.name" :icon="'el-icon-'+step.icon"
                       :key="step.slug">
                <template #icon>
                  <span :class="'mdi mdi-18px mdi-' + step.icon"></span>
                </template>
                <template #title>
                  <small class="font-italic">{{ step.name }}</small>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>-->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <!--<el-button-group>
              <el-button type="primary" icon="el-icon-arrow-left" :disabled="!previousable" @click="prevStep"
                         size="small" plain>
                {{ $t('supply.button.prev') }}
              </el-button>
              <el-button type="primary" :disabled="!nextable" @click="nextStep" size="small" plain>
                {{ $t('supply.button.next') }}<i class="el-icon-arrow-right el-icon-right"></i>
              </el-button>
            </el-button-group>-->
            <el-dropdown :disabled="!data.supplier" trigger="click"
                         style="float: right; padding: 3px 0; cursor: pointer; color: #409EFF;"
                         @command="handleAutoFill">
              <span class="el-dropdown-link">
                {{ $t('supply.button.auto_fill') }} <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item icon="mdi mdi-check-all" command="all">
                    {{ $t('supply.title.auto_fill_all') }}
                  </el-dropdown-item>
                  <el-dropdown-item icon="mdi mdi-gauge-empty" command="low">
                    {{ $t('supply.title.auto_fill_low') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div v-if="steps[active].slug === 'supplier'">
            <el-form label-position="top" size="medium">
              <el-row :gutter="50" class="py-2">
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.supplier')">
                    <el-select v-model="data.supplier" filterable :placeholder="$t('supply.title.supplier')"
                               class="full-width" @change="focusNextField" ref="supplier-ref">
                      <el-option v-for="supplier in suppliers"
                                 :key="supplier.id" :label="supplier.name" :value="supplier.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.department')">
                    <el-select v-model="data.department" filterable :placeholder="$t('supply.title.department')"
                               ref="department-ref"
                               class="full-width" @change="departmentChanged($event) || focusNextField()">
                      <el-option v-for="department in departments"
                                 :key="department.id" :label="department.name" :value="department.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.date')">
                    <el-date-picker type="date" class="full-width" @change="focusNextField" v-model="data.date"
                                    :placeholder="$t('title.date')"
                                    size="medium" ref="date-ref">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.expected_date')">
                    <el-date-picker type="date" class="full-width" @change="focusNextField" v-model="data.expected_date"
                                    :placeholder="$t('title.date')" ref="expected_date-ref"
                                    size="medium">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="24" class="mb-0">
                  <el-form-item :label="$t('supply.title.note')" class="mx-1">
                    <el-input type="textarea" class="full-width" v-model="data.note" autosize ref="note-ref"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="steps[active].slug === 'items'">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="">
                <tr>
                  <th scope="col" class="text-center">#</th>
                  <th scope="col" class="text-center">{{ $t('supply.table.item') }}</th>
                  <th scope="col" class="text-center">{{ $t('supply.table.in_stock') }}</th>
                  <th scope="col" class="text-center">{{ $t('supply.table.quantity') }}</th>
                  <th scope="col" class="text-center">{{ $t('supply.table.purchase_price') }}</th>
                  <th scope="col" class="text-center">{{ $t('supply.table.total') }}</th>
                  <th scope="col" class="text-center">{{ $t('supply.table.action') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="text-center" colspan="7">
                    <el-select @change="appendItem" :value="item" filterable v-model="item"
                               :placeholder="$t('supply.title.items')" class="full-width">
                      <el-option v-for="item in uniqueItems" :key="item.id" :label="item.name"
                                 :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
                      </el-option>
                    </el-select>
                  </td>
                </tr>
                <tr v-for="(itm, key) in data.items" :key="key">
                  <td class="text-center">{{ key + 1 }}</td>
                  <td>
                    {{ itm.name }}
                    <i class="text-primary">{{ itm.code }}</i>
                  </td>
                  <td class="text-center">{{ itm.in_stock | currency }}</td>
                  <td class="text-center">
                    <el-input :ref="`qty-${key}`" size="mini" :placeholder="$t('supply.title.quantity')"
                              @keyup.enter.native="selectNextInput(key, 'qty')"
                              v-model.number="itm.quantity" @focus="$event.target.select()"></el-input>
                  </td>
                  <td class="text-center">
                    <el-input size="mini" @keyup.enter.native="selectNextInput(key, 'price')"
                              :placeholder="$t('supply.table.purchase_price')" :ref="`price-${key}`"
                              v-model.number="itm.unit_price" class="text-center">
                    </el-input>
                  </td>
                  <!--<td class="text-center">{{ itm.quantity | currency }}</td>
                  <td class="text-center">{{ itm.unit_price | currency }}</td>-->
                  <td class="text-center">{{ itm.unit_price * itm.quantity | currency('XAF') }}</td>
                  <!-- @todo Set currency globally -->
                  <td class="text-center">
                    <el-popconfirm :title="$t('supply.message.remove_item')" :cancel-button-text="$t('button.cancel')"
                                   :confirm-button-text="$t('button.confirm')" @confirm="removeItem(key)"
                                   icon="el-icon-info" icon-color="red">
                      <template #reference>
                        <el-button icon="el-icon-minus" size="mini" type="danger">
                          {{ $t('supply.button.remove') }}
                        </el-button>
                      </template>
                    </el-popconfirm>
                  </td>
                </tr>
                <tr class="bg-light">
                  <td colspan="1"></td>
                  <td colspan="1" :class="{'f-18': !data.additional_cost.length}">
                    {{ $t(`supply.title.${data.additional_cost.length ? 'subtotal' : 'total'}`) }}
                  </td>
                  <td colspan="3"></td>
                  <td colspan="1" class="currency text-center" :class="{'f-18': !data.additional_cost.length}">
                    {{ itemSum | currency('XAF') }}
                  </td>
                  <td colspan="1"></td>
                </tr>
                <tr>
                  <td colspan="7">
                    <el-button @click="addAdditionalCost" type="primary" icon="el-icon-circle-plus-outline" plain
                               size="mini">
                      {{ $t('supply.button.add_additional_cost') }}
                    </el-button>
                  </td>
                </tr>
                <tr v-if="data.additional_cost.length">
                  <td colspan="1">#</td>
                  <td colspan="3" class="text-center">{{ $t('supply.title.additional_cost') }}</td>
                  <td colspan="1"></td>
                  <td colspan="1" class="text-center">{{ $t('supply.title.amount') }}</td>
                  <td colspan="1" align="right"></td>
                </tr>
                <tr v-for="(_, index) in data.additional_cost">
                  <td colspan="1" class="text-center">{{ index + 1 }}</td>
                  <td colspan="3">
                    <el-input size="small" :ref="'add-cost-' + index" class="full-width"
                              v-model="data.additional_cost[index].name"></el-input>
                  </td>
                  <td colspan="1"></td>
                  <td colspan="1">
                    <el-input size="small" class="full-width" v-model.number="data.additional_cost[index].amount"/>
                  </td>
                  <td colspan="1" class="text-center">
                    <el-button icon="el-icon-delete" type="danger" size="small"
                               @click="data.additional_cost.splice(index, 1)"></el-button>
                  </td>
                </tr>
                <tr class="bg-light" v-if="data.additional_cost.length">
                  <td colspan="1"></td>
                  <td colspan="1">
                    {{ $t('supply.title.subtotal') }}
                  </td>
                  <td colspan="3"></td>
                  <td colspan="1" class="currency text-center">
                    {{ additionalCostSum | currency('XAF') }}
                  </td>
                  <td colspan="1"></td>
                </tr>
                <tr v-if="data.additional_cost.length">
                  <td colspan="1"></td>
                  <td colspan="1" class="f-18">
                    {{ $t('supply.table.total') }}
                  </td>
                  <td colspan="3"></td>
                  <td colspan="1" class="f-18 currency text-center">
                    {{ payable | currency('XAF') }}
                  </td>
                  <td colspan="1"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="steps[active].slug === 'invoice'">
            <el-row class="p-b-25 p-t-25">
              <h2 class="text-center text-uppercase">{{ $t('supply.table.invoice') }}</h2>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="">
                  <tr>
                    <th class="text-center" scope="col">#</th>
                    <th class="text-center" scope="col">{{ $t('supply.table.item') }}</th>
                    <th class="text-center" scope="col">{{ $t('supply.table.quantity') }}</th>
                    <th class="text-center" scope="col">{{ $t('supply.table.unit_price') }}</th>
                    <th class="text-center" scope="col">{{ $t('supply.table.total') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(it, key) in data.items" :key="key">
                    <td class="text-center">{{ key + 1 }}</td>
                    <td class="text-center">{{ items.find(i => i.id === it.id).name }}</td>
                    <td class="text-center">{{ it.quantity }}</td>
                    <td class="text-center">{{ it.unit_price | currency }}</td>
                    <td class="text-center">{{ (it.unit_price * it.quantity) | currency }}</td>
                  </tr>
                  <tr class="bg-light pt-3">
                    <td colspan="4" class="f-18">
                      {{ $t('supply.table.total') }}
                    </td>
                    <td colspan="1" class="f-18 currency">
                      {{ payable | currency('XAF') }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </el-row>
          </div>
          <div v-if="steps[active].slug === 'payment'">
            <el-form label-position="top" size="medium">
              <el-row :gutter="50" class="py-2">
                <!--<el-col :span="12">
                  <el-input class="f-w f-8" v-model="data.paid" placeholder=""
                            size="medium">
                    <template slot="prepend">{{ $t('supply.title.paid') }}</template>
                  </el-input>
                </el-col>-->
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.supplier')">
                    <el-input class="full-width" disabled v-model="supplier"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.department')">
                    <el-input class="full-width" disabled v-model="department"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.date')">
                    <el-date-picker type="date" class="full-width" v-model="data.date" :placeholder="$t('title.date')"
                                    size="medium">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="mb-0">
                  <el-form-item :label="$t('supply.title.expected_date')">
                    <el-date-picker type="date" class="full-width" v-model="data.expected_date"
                                    :placeholder="$t('title.date')"
                                    size="medium">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="24" class="mb-0">
                  <el-form-item :label="$t('supply.title.note')" class="mx-1">
                    <el-input type="textarea" class="full-width" v-model="data.note"></el-input>
                  </el-form-item>
                </el-col>
                <!--<el-col :span="12">
                  <el-select class="full-width" v-model="data.warehouse" filterable
                             :placeholder="$t('supply.title.warehouse')">
                    <el-option v-for="warehouse in warehouses" :key="warehouse.id"
                               :label="warehouse.name" :value="warehouse.id">
                    </el-option>
                  </el-select>
                </el-col>-->
                <!--<el-col :span="24">
                  <el-row class="text-center">
                    <el-col :span="4" class="f-4">
                      {{ $t('supply.title.total') }}:
                      <span class="currency f-4">{{ payable | currency('XAF') }}</span>
                    </el-col>
                    <el-col :span="4" class="f-4">
                      {{ $t('supply.title.balance') }}:
                      <span class="currency f-4" v-if="data.paid">{{ temp.owed | currency('XAF') }}</span>
                      <span class="currency f-4" v-else>{{ payable | currency('XAF') }}</span>
                    </el-col>
                  </el-row>
                </el-col>-->
              </el-row>
            </el-form>
          </div>
          <div class="bottom">
            <el-row :gutter="20">
              <hr>
              <el-col :span="6" class="mb-0">
                <el-button v-if="previousable" class="f-w" type="primary" icon="el-icon-arrow-left"
                           @click="prevStep">
                  {{ $t('supply.button.prev') }}
                </el-button>
              </el-col>
              <el-col :span="12" align="right" style="float: right; padding-right: 0">
                <el-button :loading="loading" @click.prevent="addSupply(true)" type="primary"
                           v-if="(!editStatus === 'new') || (editStatus === 'draft')"
                           icon="el-icon-document" :disabled="!savable">
                  {{ !isEditing ? $t('supply.button.save_draft') : $t('supply.button.update_draft') }}
                </el-button>
                <el-button v-if="nextable" type="primary" @click="nextStep">
                  {{ $t('supply.button.next') }} <i class="el-icon-arrow-right"></i>
                </el-button>
                <el-button :loading="loading" :disabled="!savable" @click.prevent="addSupply(false)" type="success"
                           icon="el-icon-check" v-show="!nextable">
                  {{ editStatus === 'pending' ? $t('supply.button.update') : $t('supply.button.confirm') }}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddSupply',
  data () {
    return {
      active: 0,
      steps: [
        {
          name: this.$t('supply.title.tab.supplier'),
          slug: 'supplier',
          icon: 'file-multiple'
        },
        {
          name: this.$t('supply.title.tab.info'),
          slug: 'items',
          icon: 'format-list-bulleted'
        }/* ,
        {
          name: this.$t('supply.title.tab.invoice'),
          slug: 'invoice',
          icon: 'shopping-cart-full'
        },
        {
          name: this.$t('supply.title.tab.payment'),
          slug: 'payment',
          icon: 's-finance'
        } */
      ],
      suppliers: [],
      items: [],
      departments: [],
      warehouses: [],
      item: null,
      data: {
        supplier: null,
        items: [],
        paid: null,
        warehouse: null,
        department: null,
        date: null,
        expected_date: null,
        note: '',
        additional_cost: []
      },
      temp: {
        owed: null
      },
      isEditing: false,
      editId: null,
      editStatus: 'new',
      loading: false
    }
  },
  watch: {
    'data.paid' (value) {
      this.temp.owed = this.data.items.map(i => i.unit_price * i.quantity).reduce((v1, v2) => v1 + v2) - value
    }
  },
  computed: {
    savable () {
      return this.data.items && this.data.items.length > 0
    },
    previousable () {
      return this.active > 0
    },
    nextable () {
      return this.active < (this.steps.length - 1)
    },
    uniqueItems () {
      return this.items.map(i => i.id)
        .filter(i => !this.data.items.map(ii => ii.id).includes(i))
        .map(ii => this.items.find(i => i.id === ii))
    },
    payable () {
      return this.additionalCostSum + this.itemSum
    },
    supplier () {
      return this.data.supplier ? this.suppliers.find(s => s.id === this.data.supplier).name : null
    },
    department () {
      return this.data.department ? this.departments.find(d => d.id === this.data.department).name : null
    },
    itemSum () {
      const prices = this.data.items.map(i => i.unit_price * i.quantity)
      return prices.length ? prices.reduce((v1, v2) => v1 + v2) : 0
    },
    additionalCostSum () {
      return this.data.additional_cost.length > 0 ? this.data.additional_cost.map(ac => ac.amount || 0).reduce((acc, value) => acc + parseInt(value), 0) : 0
    }
  },
  methods: {
    handleAutoFill (filter) {
      this.$itemService.supplierItems({
        supplier: this.data.supplier,
        department: this.data.department,
        warehouse: this.data.warehouse,
        filter
      })
        .then(data => {
          for (const elt of data) {
            this.appendItem(elt.id)
          }
        })
    },
    focusNextField () {
      const fields = ['supplier', 'department', 'date', 'expected_date', 'note']
      for (const field of fields) {
        if (!this.data[field]) {
          this.$nextTick(this.$refs[`${field}-ref`].focus)
          return
        }
      }
    },
    selectNextInput (index, type) {
      if (type === 'qty') {
        // highlight price field
        this.$refs[`price-${index}`][0].$refs.input.select()
      } else {
        // highlight quantity field if exist
        if (this.data.items.length - 1 > index) {
          this.$refs[`qty-${index + 1}`][0].$refs.input.select()
        }
      }
    },
    departmentChanged (departmentId) {
      if (departmentId) {
        this.data.warehouse = this.departments.find(d => d.id === departmentId).warehouse_id
        this.getWarehouseItems()
      }
    },
    async getWarehouseItems () {
      try {
        await this.withLoading(async () => {
          this.items = await this.$warehouseService.getItems(this.data.warehouse)
        })
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in getWarehouseItems:', error)
      }
    },
    addAdditionalCost () {
      this.data.additional_cost.push({
        name: '',
        amount: null
      })
      this.$nextTick(_ => {
        this.$refs[`add-cost-${this.data.additional_cost.length - 1}`][0].$refs.input.focus()
      })
    },
    setItemPurchasePrice (id) {
      // this.item.unit_price = this.items.find(i => i.id === id).purchase_price
    },
    async addSupply (draft) {
      if (this.validItems()) {
        this.askQuestion(this.$t('supply.confirm.save'), async () => {
          try {
            await this.withLoading(async () => {
              let data

              if (this.isEditing && !draft) {
                // Update existing purchase order
                data = await this.$supplyService.updateSupply(this.editId, Object.assign({}, {
                  ...this.data,
                  draft
                }))
                this.displayMessage(this.$t('supply.update.success'), () => {
                  this.$router.push({ name: 'supplies' })
                })
              } else {
                // Create new purchase order
                data = await this.$supplyService.createSupply(Object.assign({}, {
                  ...this.data,
                  draft
                }))
                this.displayMessage(this.$t('supply.create.success'), () => {
                  this.$router.push({ name: 'supplies' })
                })
              }
            }, 'loading')
          } catch (error) {
            if (error.response) {
              if (error.response.status === 403) {
                this.displayMessage(error.response.data.message, () => {
                }, 'error', this.$t('status.error'))
              } else {
                this.displayMessage(error.message, () => {
                }, 'error', this.$t('status.error'))
              }
            }
          }
        })
      }
    },
    appendItem (id, qty = null, unitPrice = null) {
      const item = this.items.find(i => i.id === id)
      if (item && item.id) {
        const quantity = qty || (() => {
          if (item.optimal_order) {
            return item.optimal_order - item.pivot.quantity
          } else {
            return null
          }
        })()
        const data = {
          ...item,
          quantity,
          in_stock: item.pivot.quantity,
          unit_price: unitPrice || item.purchase_price
        }
        const exists = this.data.items.find(i => i.id === item.id)
        if (exists) {
          exists.quantity += data.quantity
        } else {
          this.data.items.push(data)
          if (!qty && !unitPrice) {
            // only focus when adding new item
            this.$nextTick(_ => {
              this.$refs[`qty-${this.data.items.length - 1}`][0].$refs.input.focus()
            })
          }
        }
        this.item = null
      }
    },
    removeItem (index) {
      this.data.items.splice(index, 1)
    },
    blinkElt (elt, duration = 3000) {
      if (typeof elt !== 'object') return
      elt.classList.add('slm-blink')
      setTimeout(_ => {
        elt.classList.remove('slm-blink')
      }, duration)
    },
    goToStep (slug) {
      if (this.steps.slug !== slug) this.active = this.steps.indexOf(this.steps.find(step => step.slug === slug))
    },
    validItems () {
      let key
      if (this.data.items.some((item, index) => {
        key = index
        return typeof item.quantity !== 'number' || typeof item.unit_price !== 'number'
      })) {
        this.goToStep('items')
        this.displayMessage(this.$t('supply.message.incomplete'), () => {
          this.$nextTick(_ => {
            this.$refs[`qty-${key}`][0].$refs.input.select()
            this.blinkElt(this.$refs[`qty-${key}`][0].$el.parentElement.parentElement)
          })
        }, 'warning')
        return false
      }
      if (this.data.additional_cost.some((payment, index) => {
        key = index
        return !payment.name || typeof payment.amount !== 'number'
      })) {
        this.goToStep('items')
        this.displayMessage(this.$t('supply.message.incomplete'), () => {
          this.$nextTick(_ => {
            this.$refs[`add-cost-${key}`][0].$refs.input.select()
            this.blinkElt(this.$refs[`add-cost-${key}`][0].$el.parentElement.parentElement)
          })
        }, 'warning')
        return false
      }
      return true
    },
    nextStep () {
      if (this.steps[this.active].slug === 'items') {
        if (!this.validItems()) {
          return false
        }
      }
      if (++this.active > (this.steps.length - 1)) --this.active
    },
    prevStep () {
      if (--this.active < 0) ++this.active
    },
    async withLoading (fn, loadingText) {
      this.loading = true
      try {
        await fn()
      } catch (error) {
        console.error('Error in withLoading:', error)
        this.displayMessage(error.message, () => {
        }, 'error', loadingText)
      } finally {
        this.loading = false
      }
    },

    async fetchPurchaseOrder () {
      try {
        await this.withLoading(async () => {
          // Fetch the purchase order data
          const po = await this.$supplyService.fetch(this.editId)

          // Populate the form with the purchase order data
          this.data.supplier = po.supplier.id
          this.data.department = po.store.id
          this.data.warehouse = po.store.warehouse_id || this.warehouses.find(w => !!w.default).id
          this.data.date = po.date
          this.data.expected_date = po.expected_date
          this.data.note = po.note

          this.editStatus = po.status

          await this.getWarehouseItems()
          // Handle items
          for (const item of po.items) {
            this.$nextTick(() => {
              this.appendItem(item.item_id, item.quantity, item.unit_price)
            })
          }

          // Handle additional costs if any
          if (po.additional_cost && po.additional_cost.length) {
            this.data.additional_cost = po.additional_cost
          }

          // Get warehouse items for the selected warehouse
          // await this.getWarehouseItems()
        }, 'loading')
      } catch (error) {
        console.error('Error fetching purchase order:', error)
      }
    }
  },
  async mounted () {
    // Check if we're editing an existing purchase order
    if (this.$route.query.id && this.$route.query.edit) {
      this.isEditing = true
      this.editId = this.$route.query.id
      this.$emit('parent-title', this.$t('supply.title.edit_supply'))
    } else {
      this.$emit('parent-title', this.$t('supply.title.new_supply'))
    }

    try {
      await this.withLoading(async () => {
        // Fetch the purchase order data
        // Load suppliers
        this.suppliers = await this.$supplierService.getSuppliers()

        // Load departments
        this.departments = await this.$departmentService.getDepartmentsWithWarehouse()

        // Load warehouses
        const warehouses = await this.$warehouseService.getWarehouses()
        this.warehouses = warehouses
        if (!this.isEditing) {
          this.data.warehouse = warehouses.find(w => !!w.default).id
        }

        // If editing, fetch the purchase order data
        if (this.isEditing && this.editId) {
          await this.fetchPurchaseOrder()
        }
      }, 'loading')
    } catch (error) {
      console.error('Error in mounted:', error)
    }
  }
}
</script>

<style scoped>
@keyframes slm-blink {
  0% {
    background-color: rgba(255, 153, 0, 0.66);
  }
  100% {
    background-color: transparent;
  }
}

@-webkit-keyframes slm-blink {
  0% {
    background-color: rgba(255, 153, 0, 0.66);
  }
  100% {
    background-color: transparent;
  }
}

.slm-blink {
  -webkit-animation: slm-blink 1s linear infinite;
  -moz-animation: slm-blink 1s linear infinite;
  animation: slm-blink 1s linear infinite;
}
</style>
